import angular from 'angular';

import {} from './register.less';

module.exports = angular.module('market.routes.humans.register', [
  require('angular-ui-router')
])
.config(function($stateProvider) {
  $stateProvider.state('humans.register', {
    url: '/register',
    template: require('./register.jade')(),
    controllerAs: 'registerCtrl',
    controller: class {
      constructor($window) {
        this.$window = $window;
      }

      redirectToHome() {
        this.$window.location = '/';
      }
    }
  });
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/market/routes/humans/register.js
 **/